import { c as _c } from "react/compiler-runtime";
import { classNames, Modal } from "@opensea/ui-kit";
import { CurrencySelectContent } from "./CurrencySelectContent";
export const CurrencySelectModal = t0 => {
  const $ = _c(17);
  let className;
  let onOpenChange;
  let open;
  let rest;
  if ($[0] !== t0) {
    ({
      open,
      onOpenChange,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onOpenChange;
    $[3] = open;
    $[4] = rest;
  } else {
    className = $[1];
    onOpenChange = $[2];
    open = $[3];
    rest = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = classNames("max-h-[55vh]", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== onOpenChange) {
    t2 = () => onOpenChange?.(false);
    $[7] = onOpenChange;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== rest || $[10] !== t1 || $[11] !== t2) {
    t3 = <CurrencySelectContent className={t1} onClose={t2} {...rest} />;
    $[9] = rest;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== onOpenChange || $[14] !== open || $[15] !== t3) {
    t4 = <Modal className="h-[55vh] overflow-hidden bg-bg-primary" content={t3} onOpenChange={onOpenChange} open={open} withCloseIcon={false} />;
    $[13] = onOpenChange;
    $[14] = open;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};